import HomePagePersonalization from './HomePagePersonalization';

export const PersonalizationPage = () => (
  <>
    <HomePagePersonalization />
    {/* <Other Pages Personalizations> or other sections will go here */}
  </>
);
